
<template>
    <transition name="fade">
        <div class="ui-confirm" :class="{ 'ios': isIOS, 'show': show }" v-show="show">
            <div :class="`ui-confirm-dialog ${middleText ? 'long' : ''}`">
                <img class="dialog-close" @click="handleClose($event, 'closeBtn')" src="../../../assets/contribute/close-icon.png"/>
                <div class="dialog-content">
                    <div class="dialog-title" v-if="title">{{title}}</div>
                    <div class="dialog-desc">{{content}}</div>
                </div>
                <div class="dialog-btns-v3">
                    <div class="dialog-btns-confirm" v-if="confirmText" @click="handleConfirm">{{confirmText}}</div>
                    <div class="dialog-btns-cancel" v-if="middleText" @click="handleMiddle">{{middleText}}</div>
                    <div class="dialog-btns-cancel" v-if="cancelText" @click="handleClose($event, 'cancelBtn')">{{cancelText}}</div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { isIOS } from '../../../utils/ua';

export default {
    name: 'confirmV3',
    data() {
        return {
            isIOS: isIOS(),
            show: false,
            title: '',
            content: '',
            cancelText: '取消',
            confirmText: '确认',
            middleText: '仅上架无人像视频',
            onClose: () => {},
            onConfirm: () => {},
            onMiddle: () => {},
        };
    },
    methods: {
        handleClose(event, position) {
            event.stopPropagation();
            this.show = false;
            typeof this.onClose === 'function' && this.onClose(position);
        },
        handleConfirm(event) {
            event.stopPropagation();
            this.show = false;
            typeof this.onConfirm === 'function' && this.onConfirm();
        },
        handleMiddle(event) {
            event.stopPropagation();
            this.show = false;
            typeof this.onMiddle === 'function' && this.onMiddle();
        },
    },
    watch: {
        /**
         * @desc 弹框时禁止滚动
         */
        show(value) {
            if (value) {
                // show
                document.body.style.overflow = 'hidden';
            } else {
                // hidden
                document.body.style.overflow = 'initial';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/px2rem.scss';
// 设计稿宽度
$designWidth: 375;

.ui-confirm {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .7);
    z-index: 1000;
    user-select: none;
    &.ios {
        .ui-confirm-dialog {
            transform: translate(-50%, -80%) scale(1);
        }
    }
    .ui-confirm-dialog {
        position: absolute;
        top: 50%;
        left: 50%;
        padding: px2rem(20);
        width: px2rem(280);
        min-height: px2rem(232);
        border-radius: px2rem(8);
        background-color: #fff;
        transform: translate(-50%, -50%);
        transition: transform .3s ease-in-out;
    }
    .long {
        min-height: px2rem(280);
    }
    .dialog-close {
        position: absolute;
        top: px2rem(10);
        right: px2rem(10);
        width: px2rem(12);
        height: px2rem(12);
        padding: px2rem(5);
        box-sizing: content-box;
    }
    .dialog-content {
        padding: px2rem(5) 0 px2rem(5);
        min-height: px2rem(100);
        font-size: px2rem(14);
        line-height: px2rem(20);
        color: #222222;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        .dialog-title {
            font-size: px2rem(16);
            font-weight: bold;
            text-align: center;
            color: #222222;
        }
        .dialog-desc {
            margin: px2rem(5) 0;
            text-align: center;
        }
    }
    .dialog-btns-v3 {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        min-height: px2rem(96);
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        font-family: PingFang SC;
        font-size: px2rem(15);
        line-height: px2rem(48);
        border-top: 1px solid rgba(22, 24, 35, 0.12);
        .dialog-btns-cancel {
            width: 100%;
            height: px2rem(48);
            color: rgba(22, 24, 35, 0.75);
            border-top: 1px solid rgba(22, 24, 35, 0.12);
        }
        .dialog-btns-confirm {
            width: 100%;
            height: px2rem(48);
            color: #161823;
            font-weight: 500;
        }
    }
}
</style>
